import { Content } from './Content'

export enum ExerciseType {
  AUDIO = 'AUDIO',
  AUDIO_OPEN_TEXT = 'AUDIO_OPEN_TEXT',
  CHALLENGE = 'CHALLENGE',
  IMAGE = 'IMAGE',
  MULTIPLE_CHOICE = 'MULTIPLE_CHOICE',
  MULTIPLE_STEPS = 'multiple_steps',
  OPEN_TEXT = 'OPEN_TEXT',
  SCALE = 'SCALE',
  SOCIAL_MEDIA = 'SOCIAL_MEDIA',
  TEXT = 'TEXT',
}

export interface PlayerExercise {
  audioUrl?: string
}

export interface SocialExercise extends Content {}
export interface MotivationExercise {
  motivation: string | Array<string>
}

export interface ImageExercise {
  src: string
}

export interface Option {
  option: string
}

export type ExerciseStepData =
  | PlayerExercise
  | SocialExercise
  | MotivationExercise
  | ImageExercise
  | Option[]
  | {}
  | any

export interface ExerciseStep {
  id: number
  title: string
  type: ExerciseType
  context: string
  stepNumber: number
  header: string
  data?: ExerciseStepData
}

export interface ExerciseData {
  id: number
  title: string
  steps: ExerciseStep[]
}

export type StepResponse = {
  stepId: number
  response: any
}

export type ExerciseAnswer = {
  exerciseId: number
  completed: boolean
  responses: {
    stepResponses: StepResponse[]
  }
}

export interface OnResponseSubmit {
  (stepId: number, response: any): Promise<void>
}
